import { Component } from '@angular/core';
import { BannerComponent } from '../components/banner/banner.component';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [BannerComponent, TranslatePipe],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss'
})
export class ErrorComponent {

  constructor(private router: Router) {

  }

  ngOnInit() {
    document.getElementById("error-header")?.focus()
  }

  onBack(){
    this.router.navigate(["/"])
  }
}
